import React from 'react';

import svg from './assets/icons-16-chevron-right.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconChevronRight = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-chevron-right" />
);
